import React, { FunctionComponent } from "react";
import AdUnit, { Tab } from "@own-local/ad-unit/lib/AdUnit";
import { translateString } from "@own-local/ad-utils/lib/translate";

import { OrigamiDataType, BusinessDataType } from "../FillOrigamiStep";

import "./ad_unit.scss";

const defaultData = {
  adId: "merlin",
  businessId: "",
  partnerId: "",
  partnerName: "",
  partnerDomain: "",
  name: "merlin",
  about: "",
  categories: [],
  // Workaround for <ContactContent /> headline can't be empty in ad-unit
  headlines: ["<br>"],
  contact: {
    place: { address1: "", city: "", country: "US", subdivision: "", postalCode: "" },
    phones: [{ number: "" }],
    email: "",
    website: "",
    noFollowLink: false,
  },
  images: {
    picture: { sm: "", md: "", lg: "" },
    offsets: { horizontal: 5, vertical: 0, square: 0 },
    logo: "",
  },
  print: {},
  social: { instagram: "", twitter: "", facebook: "" },
  locale: "en",
  partnerContactEnabled: false,
};

type Layout = "1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | undefined;

type OrigamiPreviewProps = {
  origamiData: OrigamiDataType;
  spell: string;
  publisherCountry?: string;
  switchDetails?: boolean;
  selectedTab?: Tab;
  showExpanded?: boolean;
};

const buildAdUnitData = (origamiData: OrigamiDataType, publisherCountry?: string) => {
  const data = JSON.parse(JSON.stringify(defaultData));
  const backgroundImageUrl = origamiData["background"];
  const logoUrl = origamiData["logo"];
  data.images.picture = {
    sm: backgroundImageUrl as string,
    md: backgroundImageUrl as string,
    lg: backgroundImageUrl as string,
  };
  data.images.logo = logoUrl as string;

  if (origamiData["caption"]) data.headlines[0] = origamiData["caption"] as string;
  else data.headlines[0] = "<br>";

  data.name =
    (origamiData["business_name"] as string) ||
    (origamiData["business"] &&
      ((origamiData["business"] as BusinessDataType)["name"] as string)) ||
    "";

  let phoneNumber = ""

  if (!!origamiData["address"])
    data.contact.place.address1 = origamiData["address"] as string;
  if (!!origamiData["city"]) data.contact.place.city = origamiData["city"] as string;
  if (!!origamiData["state"])
    data.contact.place.subdivision = origamiData["state"] as string;
  if (!!origamiData["zip"]) data.contact.place.postalCode = origamiData["zip"] as string;
  if (!!origamiData["business_phone"]) {
    if (publisherCountry && (publisherCountry === 'US' || publisherCountry === 'CA')) {
      if (origamiData["business_phone"].toString().includes("+1")) {
        phoneNumber = origamiData["business_phone"] as string;
      } else{
        phoneNumber = `+1${origamiData["business_phone"]}` as string;
      }
    } else {
      phoneNumber = origamiData["business_phone"] as string;
    }
    data.contact.phones[0].number = phoneNumber as string;
  }
  if (!!origamiData["website"]) data.contact.website = origamiData["website"] as string;

  if (!!origamiData["facebook"]) data.social.facebook = origamiData["facebook"] as string;
  if (!!origamiData["twitter"]) data.social.twitter = origamiData["twitter"] as string;
  if (!!origamiData["instagram"])
    data.social.instagram = origamiData["instagram"] as string;
  if (!!origamiData["additional_text"])
    data.about = `<p>${origamiData["additional_text"]}</p>`;
  if (!!origamiData["email"]) {
    data.contact.email = origamiData["email"] as string;
    data.partnerContactEnabled = true;
  } else {
    data.partnerContactEnabled = false;
  }

  if (publisherCountry) {
    data.contact.place.country = publisherCountry;
  }

  return data;
};

const OrigamiPreview: FunctionComponent<OrigamiPreviewProps> = ({
  origamiData,
  publisherCountry,
  showExpanded = true,
  selectedTab = undefined,
}: OrigamiPreviewProps) => (
  <div className="ownlocal-unit">
    <AdUnit
      data={buildAdUnitData(origamiData, publisherCountry)}
      track={() => false}
      mapDisabled={false}
      layoutParam={origamiData["layout"] as Layout}
      translateString={translateString}
      intialExpanded={showExpanded}
      selectedTab={selectedTab}
      keepDocumentTitle
      showShareButtons
    />
  </div>
);

export default OrigamiPreview;
